var list = document.getElementsByClassName("cardssteps_number");
for (var i = 1; i <= list.length; i++) {
    list[i].innerHTML = i;
}